import * as yup from 'yup';

const localization = {
  shouldUseOnlyUSAPhoneNumber: 'Please use only US phone number like this +11234567890.',
  USAPhoneNumberLength: (length: number) =>
    `Phone number should be 10 digits after county code (+1), but your is ${length}`,
  emailOrPhoneIsRequired: 'Email or Phone number is required.',
  invalidEmail: 'Please enter valid E-mail address.',
  emailIsRequired: 'Email is required.',
  shouldAgreeWithSMSAgreement:
    'Your consent to the sms agreement is required. Otherwise, you cannot register for the service.',
  shouldAgreeWithPrivacy:
    'Your consent to the Terms and Conditions is required. Otherwise, you cannot register for the service.',
};

type LocalizationMessages = typeof localization;

export function prepareSchema({
  isEnabledSMSAgreement = false,
  isEnabledPhoneNumber = false,
  isEnabledCheckedAgreeWithPrivacy = false,
  messages = localization,
}: {
  isEnabledSMSAgreement?: boolean;
  isEnabledPhoneNumber?: boolean;
  isEnabledCheckedAgreeWithPrivacy?: boolean;
  messages?: LocalizationMessages;
}) {
  let schema = yup.object().shape({});

  if (isEnabledPhoneNumber) {
    const contactSchema = yup
      .string()
      .test('email-or-us-phone', function (value = '') {
        if (isPhoneNumber(value)) {
          if (!isUSACountryCode(value)) {
            return this.createError({ message: messages.shouldUseOnlyUSAPhoneNumber });
          }
          if (!isUSAPhoneNumberByLength(value)) {
            return this.createError({
              message: messages.USAPhoneNumberLength(value.slice(2).length),
            });
          }
        } else if (!yup.string().email().isValidSync(value)) {
          return this.createError({ message: messages.invalidEmail });
        }
        return true;
      })
      .required(messages.emailOrPhoneIsRequired);

    schema = schema.shape({
      contact: contactSchema,
    });
  } else {
    schema = schema.shape({
      contact: yup.string().email(messages.invalidEmail).required(messages.emailIsRequired),
    });
  }

  if (isEnabledSMSAgreement) {
    schema = schema.shape({
      agreeWithSMSAgreement: yup.boolean().oneOf([true], messages.shouldAgreeWithSMSAgreement),
    });
  }

  if (isEnabledCheckedAgreeWithPrivacy) {
    schema = schema.shape({
      agreeWithPrivacy: yup.boolean().oneOf([true], messages.shouldAgreeWithPrivacy),
    });
  }

  return schema;
}

function isPhoneNumber(number: string) {
  return /^\d+$/.test(number) || /^\+\d+$/.test(number);
}

function isUSACountryCode(phoneNumber: string) {
  return /^\+1/.test(phoneNumber);
}

function isUSAPhoneNumberByLength(phoneNumber: string) {
  return /^\d{10}$/.test(phoneNumber.slice(2));
}
